import { LoadingToast } from "@fanka/ui-admin";
import { CheckInPage } from "@on-site/components/pages/checkIn";
import { DirectVisitPage } from "@on-site/components/pages/directVisit";
import { InvalidPage } from "@on-site/components/pages/invalid";
import { useClinicParams } from "@on-site/hooks/useClinicParams";
import { useAppApiSWR } from "@on-site/libs/swr/useAppApiSWR";

export const EventConditionPage = ({ patientNo }: { patientNo: string }) => {
  const { clinicId } = useClinicParams();

  const { data, isLoading, error } = useAppApiSWR("/api/v2/on-site/clinics/{clinicId}/events", {
    enabled: !!patientNo,
    params: {
      path: {
        clinicId,
      },
      query: {
        externalPatientReference: patientNo,
      },
    },
  });

  if (isLoading) return <LoadingToast isLoading />;

  if (error) return <InvalidPage />;

  if (data?.events && data.events.length >= 1) return <CheckInPage events={data.events} />;

  return <DirectVisitPage patientNo={patientNo} />;
};
